import { render, staticRenderFns } from "./distributionProjectionChart.vue?vue&type=template&id=6680f34b&"
import script from "./distributionProjectionChart.vue?vue&type=script&lang=js&"
export * from "./distributionProjectionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports